const API_URL = process.env.VUE_APP_API_URL || "http://localhost:8000";

const MUTATING_METHODS = ["POST", "PUT", "PATCH", "DELETE"];

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);

  if (parts.length === 2) {
    return decodeURIComponent(parts.pop().split(";").shift());
  }

  return null;
}

function normalizeMethod(method) {
  return (method || "GET").toUpperCase();
}

function shouldEnsureCsrf(method) {
  return MUTATING_METHODS.includes(normalizeMethod(method));
}

export async function ensureCsrfCookie() {
  const response = await fetch(`${API_URL}/sanctum/csrf-cookie`, {
    method: "GET",
    credentials: "include",
    headers: {
      Accept: "application/json",
    },
  });

  if (!response.ok) {
    throw new Error("Não foi possível iniciar a sessão segura.");
  }
}

export async function apiFetch(path, options = {}, retryOnCsrfError = true) {
  const method = normalizeMethod(options.method);

  if (shouldEnsureCsrf(method) && !getCookie("XSRF-TOKEN")) {
    await ensureCsrfCookie();
  }

  const isFormData = options.body instanceof FormData;
  const xsrfToken = getCookie("XSRF-TOKEN");

  const headers = {
    Accept: "application/json",
    ...(isFormData ? {} : { "Content-Type": "application/json" }),
    ...(xsrfToken ? { "X-XSRF-TOKEN": xsrfToken } : {}),
    ...(options.headers || {}),
  };

  const response = await fetch(`${API_URL}${path}`, {
    ...options,
    method,
    credentials: "include",
    headers,
    body:
      options.body && !isFormData && typeof options.body !== "string"
        ? JSON.stringify(options.body)
        : options.body,
  });

  if (response.status === 419 && retryOnCsrfError) {
    await ensureCsrfCookie();

    return apiFetch(path, options, false);
  }

  const contentType = response.headers.get("content-type");
  const data = contentType?.includes("application/json")
    ? await response.json()
    : await response.text();

  if (!response.ok) {
    const message =
      data?.message ||
      Object.values(data?.errors || {})?.flat()?.[0] ||
      "Erro ao comunicar com a API.";

    throw new Error(message);
  }

  return data;
}

export { API_URL };
